import React, { useMemo, useState } from "react";
import styles from "./TicketProcessingRules.module.scss";
import MoreEllipsis from "../../../assets/images/ellipsisListing.svg";
import EditIcon from "../../../assets/images/edit-document-icon.svg";
import { Col, Popover, Row } from "antd";
import { PopoverTrigger } from "../../../enums/PopoverEnums";
import { PlacementPositions } from "../../../enums/PlacementPositionsEnums";
import {
  getDefaultValues,
  getTicketProcessingRuleList,
  TicketProcessingRulesConstants,
  TicketProcessingRulesValidation,
} from "./constants";
import TicketProcessingRulesForm from "./TicketProcessingRulesForm";
import Form from "../../Form";
import RuleEngineServices from "../../../services/ruleEngine.services";

const TicketProcessingRules = () => {
  const { FetchRuleEngineContents } = RuleEngineServices();
  const { data: ruleEngineContent } = FetchRuleEngineContents();
  const ticketProcessingRuleList = getTicketProcessingRuleList(
    ruleEngineContent?.data?.[0] ?? {}
  );
  const [isEditFormOpen, setIsEditFormOpen] = useState<boolean>(false);

  const handleOpenEditForm = () => setIsEditFormOpen(true);
  const handleCloseEditForm = () => setIsEditFormOpen(false);
  const defaultValues = useMemo(() => {
    return getDefaultValues(ruleEngineContent?.data?.[0] ?? {});
  }, [ruleEngineContent]);
  return (
    <>
      <Form
        key={ruleEngineContent?.data?.[0]?.id || "default"}
        defaultValues={defaultValues}
        values={defaultValues}
        validationSchema={TicketProcessingRulesValidation}
      >
        {({ control: { handleSubmit } }) => {
          return (
            <TicketProcessingRulesForm
              id={ruleEngineContent?.data?.[0]?.id}
              isOpen={isEditFormOpen}
              handleClose={handleCloseEditForm}
              handleSubmit={handleSubmit}
            />
          );
        }}
      </Form>
      <div className={styles.ticketProcessingRuleContainer}>
        <Popover
          trigger={PopoverTrigger.HOVER}
          overlayClassName={styles.editPopoverWrapper}
          placement={PlacementPositions.BOTTOM}
          content={
            <span onClick={handleOpenEditForm}>
              <img src={EditIcon} />
              <span className={styles.editOptionText}>
                {TicketProcessingRulesConstants.EDIT_OPTION}
              </span>
            </span>
          }
        >
          <span className={styles.editEllipsis}>
            <img src={MoreEllipsis} />
          </span>
        </Popover>
        <div className={styles.ruleListWrapper}>
          {ticketProcessingRuleList?.map(([label, value], rowIndex) => (
            <div className={styles.rowWrapper} key={rowIndex}>
              <Row>
                <Col span={10}>
                  <div className={styles.tableLabels}>{label}</div>
                </Col>
                <Col span={14}>
                  <div className={styles.tableContentValues}>{value}</div>
                </Col>
              </Row>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default TicketProcessingRules;
